import axios from 'axios';
import React, { useState, useEffect } from 'react';
import styled from 'styled-components'

import { Flex, Text, Spinner } from "../../../../components";
import { Modal, ModalContainer, ModalButton, Input, Select, Label, TextArea } from "../../components";
import { NotificationContainer, NotificationManager } from 'react-notifications';
import Release from "./Release";

const Header = styled(Flex)`
  border-bottom: 1px solid #414568;
  padding: 15px 30px;
`;

const Search = styled.input`
  background: transparent;
  flex-grow: 1;
  margin-right: 20px;
  height: 100%;
  color: #fff;
  
  &::placeholder {
    color: #7178B2
  }
`;

const Button = styled.button`
  border-radius: 4px;
  padding: 0 18px;
  height: 32px;
  text-align: center;
  color: white;
  font-size: 12px;
  font-weight: 600;
  background: ${props => props.bg}
`;

const Content = styled(Flex)`
  padding: 30px;
`;

const HeaderRow = styled(Flex)`
  border-bottom: 1px solid #414568;
  padding: 18px 24px;
  margin-bottom: 24px;
  color: #7178B2;
  font-weight: 600;
  font-size: 12px;
`;

const Releases = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [releases, setReleases] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setEditModal] = useState(false);
  const [licenseTypes, setLicenseTypes] = useState(false);

  const [releasePayload, setReleasePayload] = useState({
    password: "",
    license_type_id: null,
    stockAmount: null,
    force_cancel: 0,
    whitelist: null
  });

  const [editReleasePayload, setEditReleasePayload] = useState({
    releaseID: null,
    password: "",
    license_type_id: null,
    stockAmount: null,
    force_cancel: 0,
    whitelist: null
  });

  const editRelease = (releaseData) => {
    setEditModal(true);
    setEditReleasePayload({
      releaseID: releaseData.id,
      password: releaseData.password,
      license_type_id: releaseData.license_type_id,
      stockAmount: releaseData.stock_amount,
      force_cancel: releaseData.force_cancel,
      whitelist: releaseData.whitelist
    })
  }

  const hideEditModal = () => {
    setEditModal(false);
  }

  const generateRelease = () => {

    if (releasePayload.password.length <= 0) {
      return NotificationManager.error("Password missing");
    }

    if (releasePayload.license_type_id == null) {
      return NotificationManager.error("License Type missing");
    }

    if (releasePayload.stockAmount == null) {
      return NotificationManager.error("Stock Amount missing");
    }

    setIsLoading(true);

    axios({
      method: 'POST',
      url: '/api/admin/releases/create-release',
      data: releasePayload,
    }).then(res => {
      setReleases(res.data.releases);
      setShowModal(false);
      setIsLoading(false);
    });

  }


  const updateRelease = () => {

    if (editReleasePayload.password.length <= 0) {
      return NotificationManager.error("Password missing");
    }

    if (editReleasePayload.license_type_id == null) {
      return NotificationManager.error("License Type missing");
    }

    if (editReleasePayload.stockAmount == null) {
      return NotificationManager.error("Stock Amount missing");
    }

    setIsLoading(true);

    axios({
      method: 'put',
      url: '/api/admin/releases/update-release',
      data: editReleasePayload,
    }).then(res => {
      setReleases(res.data.releases);
      hideEditModal();
      setIsLoading(false);
    });

  }

  const deleteRelease = (releaseID) => {

    setIsLoading(true);

    axios
      .delete('/api/admin/releases/delete-release?id=' + releaseID)
      .then(res => {
        setReleases(res.data.releases);
        setIsLoading(false);
      })
      .catch(err => {
        console.error(err);
      });

  }

  const refreshList = () => {

    setIsLoading(true);

    axios
      .get('/api/admin/releases')
      .then(res => {
        setReleases(res.data.releases);
        setIsLoading(false);
      })
      .catch(err => {
        console.error(err);
      });
  }

  const renderLicenseTypes = (isEdit = false) => {

    if (isEdit) {

      return (
        <Select
          value={editReleasePayload.license_type_id}
          onChange={(e) => {
            setEditReleasePayload({
              ...editReleasePayload,
              license_type_id: e.target.value
            })
          }}
        >
          {licenseTypes.map((value) => {
            return <option value={value.id}>{value.name} | {value.label}</option>
          })}
        </Select>
      )

    } else {

      return (
        <Select
          value={releasePayload.license_type_id}
          onChange={(e) => {
            setReleasePayload({
              ...releasePayload,
              license_type_id: e.target.value
            })
          }}
        >
          {licenseTypes.map((value) => {
            return <option value={value.id}>{value.name} | {value.label}</option>
          })}
        </Select>
      )

    }



  }

  const searchRelease = (value) => {

    if (value.length > 0) {

      axios
        .get('/api/admin/releases/search-release?search=' + value)
        .then(res => {
          setReleases(res.data.releases);
        })
        .catch(err => {
          console.error(err);
        });

    } else {
      axios
        .get('/api/admin/releases')
        .then(res => {
          setReleases(res.data.releases);
        })
        .catch(err => {
          console.error(err);
        });
    }

  }

  useEffect(() => {
    axios
      .get('/api/admin/releases')
      .then(res => {
        setReleases(res.data.releases);
        setLicenseTypes(res.data.licenseTypes);
        let licenseTypeID = res.data.licenseTypes.length > 0 ? res.data.licenseTypes[0].id : null;
        setReleasePayload({
          ...releasePayload,
          license_type_id: licenseTypeID
        });
        setIsLoading(false);
      })
      .catch(err => {
        console.error(err);
      });
  }, []);

  if (isLoading) return (
    <Spinner></Spinner>
  );

  return (
    <>
      <Header h="90px" w="100%" align="center">
        <Search placeholder="Search releases" onKeyPress={e => e.key == "Enter" ? searchRelease(e.target.value) : ""} />
        <Flex fg="1" />
        <Button bg="#0393FF" onClick={() => setShowModal(true)}>Generate Release</Button>
        <Flex w="12px" />
        <Button bg="#F32FE0" onClick={() => refreshList()}>Refresh List</Button>
      </Header>
      <Content w="100%" minw="900px" dir="column">
        <HeaderRow w='100%' minw="840px">
          <Flex w="10%">Password</Flex>
          <Flex w="15%">License Type</Flex>
          <Flex w="10%">Stock</Flex>
          <Flex w="10%">Force Cancel</Flex>
          <Flex w="10%">Whitelist</Flex>
          <Flex w="10%">Created At</Flex>
        </HeaderRow>
        {releases.map((value) => {
          return <Release editRelease={editRelease} deleteRelease={deleteRelease} data={value} />
        })}
      </Content>

      <NotificationContainer />

      {showModal &&
        <ModalContainer>
          <Modal maxHeight="80%" dir="column">
            <Text.Heading size="18">Generate Release</Text.Heading>
            <Flex h="24px" />
            <Label>Password</Label>
            <Flex h="16px" />
            <Input
              type="text"
              placeholder="Password"
              onChange={(e) => {
                setReleasePayload({
                  ...releasePayload,
                  password: e.target.value
                })
              }}
            />
            <Flex w="16px" />
            <Flex h="24px" />
            <Label>License Type</Label>
            <Flex h="16px" />
            {renderLicenseTypes(false)}
            <Flex h="24px" />
            <Label>Stock Amount</Label>
            <Flex h="16px" />
            <Input
              type="number"
              placeholder="Stock Amount"
              onChange={(e) => {
                setReleasePayload({
                  ...releasePayload,
                  stockAmount: e.target.value
                })
              }}
            />
            <Flex h="24px" />
            <Label>Force Cancel</Label>
            <Flex h="16px" />
            <Select
              value={releasePayload.force_cancel}
              onChange={(e) => {
                setReleasePayload({
                  ...releasePayload,
                  force_cancel: e.target.value
                })
              }}
            >
              <option value="0">No</option>
              <option value="1">Yes</option>
            </Select>
            <Flex h="24px" />
            <Label>Whitelisted IDs - ( Delimited by : )</Label>
            <Flex h="16px" />
            <TextArea height="50px"
              onChange={(e) => {
                setReleasePayload({
                  ...releasePayload,
                  whitelist: e.target.value
                })
              }}
            />
            <Flex w="16px" />
            <Flex h="24px" />
            <Flex dir="row" w="100%">
              <ModalButton onClick={() => setShowModal(false)} bg="#202441">Cancel</ModalButton>
              <Flex w="16px" />
              <ModalButton bg="#F32FE0" onClick={generateRelease}>Generate Release</ModalButton>
            </Flex>
          </Modal>
        </ModalContainer>
      }

      {showEditModal &&
        <ModalContainer>
          <Modal maxHeight="80%" dir="column">
            <Text.Heading size="18">Update Release</Text.Heading>
            <Flex h="24px" />
            <Label>Password</Label>
            <Flex h="16px" />
            <Input
              type="text"
              placeholder="Password"
              value={editReleasePayload.password}
              onChange={(e) => {
                setEditReleasePayload({
                  ...editReleasePayload,
                  password: e.target.value
                })
              }}
            />
            <Flex w="16px" />
            <Flex h="24px" />
            <Label>License Type</Label>
            <Flex h="16px" />
            {renderLicenseTypes(true)}
            <Flex h="24px" />
            <Label>Stock Amount</Label>
            <Flex h="16px" />
            <Input
              type="number"
              placeholder="Stock Amount"
              value={editReleasePayload.stockAmount}
              onChange={(e) => {
                setEditReleasePayload({
                  ...editReleasePayload,
                  stockAmount: e.target.value
                })
              }}
            />
            <Flex h="24px" />
            <Label>Force Cancel</Label>
            <Flex h="16px" />
            <Select
              value={editReleasePayload.force_cancel}
              onChange={(e) => {
                setEditReleasePayload({
                  ...editReleasePayload,
                  force_cancel: e.target.value
                })
              }}
            >
              <option value="0">No</option>
              <option value="1">Yes</option>
            </Select>
            <Flex h="24px" />
            <Label>Whitelisted IDs - ( Delimited by : )</Label>
            <Flex h="16px" />
            <TextArea height="50px"
              value={editReleasePayload.whitelist}
              onChange={(e) => {
                setEditReleasePayload({
                  ...editReleasePayload,
                  whitelist: e.target.value
                })
              }}
            />
            <Flex w="16px" />
            <Flex h="24px" />
            <Flex dir="row" w="100%">
              <ModalButton onClick={hideEditModal} bg="#202441">Cancel</ModalButton>
              <Flex w="16px" />
              <ModalButton bg="#F32FE0" onClick={updateRelease}>Update Release</ModalButton>
            </Flex>
          </Modal>
        </ModalContainer>
      }
    </>
  )
}

export default Releases;
